module.exports = __webpack_public_path__ + "7aeabf655f7532eefe593c113e59b938.svg";